<template>
    <div class="ThickChart">
        <span
            class="ThickChart__thick"
            :style="thickStyle"
        ></span>
        <span
            class="ThickChart__thin"
            :style="thinStyle"
        ></span>
    </div>
</template>
<script>
export default {
    name: 'ThickChart',
    props: {
        percent: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
    computed: {
        thickStyle(){
            return {
                width: `${this.percent}%`,
                background: this.color
            };
        },
        thinStyle(){
            return {
                background: this.color
            };
        }
    }
};
</script>
<style lang="scss">
    .ThickChart {
        width: 100%;
        display: flex;
        position: relative;

        &__thick {
            height: 0.5rem;
            border-radius: 4px;
        }
        &__thin {
            width: 100%;
            height: 2px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
        }
    }
</style>
